import { useState } from "preact/hooks";
import { GET, GET_CHANGE_DEVICE_OPTION } from "../../../services";
import { IStateChangeDevice } from "../interfaces/state";


export const useGetOption = () => {
  const [optionsChangeDevice, setOptionsChangeDevice] = useState(
    [] as IStateChangeDevice[]
  );

  const onFetchOptionChangeDevice = async () => {
    try {
      const res = await GET(GET_CHANGE_DEVICE_OPTION);
      const { options: optcd } = res.result;
      setOptionsChangeDevice(optcd);
    } catch (error) {
      console.log(error);
    }
  };
  return {
    onFetchOptionChangeDevice,
    optionsChangeDevice,
  };
};
